import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { Helmet } from "react-helmet";   // 👈 thêm vào đây
import Accounts_product from "./accounts_product.jsx";
import Orders_vip from './orders_vip.jsx'; // file con
import { alert_error, alert_success, copy_native } from "../../../../AppContext";
import { Cookies } from "../../../../index.js";

export default function Orders_main() {
    const { slug_1, slug_2, slug_3, slug_4 } = useParams();
    const [accounts_product, set_accounts_product] = useState('');
    const [services_info, set_services_info] = useState('');
    const [show_vip, set_show_vip] = useState(false);
    const navigate = useNavigate(); // Hook để điều hướng

    function laydulieu(value) {
        axios.get("https://hust.media/api/orders/account/sellers/services/services_info.php", {
            params: {
                id: value
            }
        })
            .then((response) => {
                set_services_info(response.data.services);
            })
            .catch((error) => alert_error(error));
    };
    const show_orders_vip = () => {
        const apikey = Cookies.get("apikey");
        if (!apikey) {
            alert_success('chưa đăng nhập nhé cậu iu');
            setTimeout(() => {
                switch_router('/reactapp/');
            }, 1000); // 1000ms = 1s
        } else {
            set_show_vip(!show_vip);
        }
    };
    useEffect(() => {
        if (typeof slug_3 === "string") {
            const match = slug_3.match(/_(\d+)$/);
            if (match) {
                const soSauUnderscore = match[1]; // "323232"
                laydulieu(soSauUnderscore);
            }
        }
    }, []);
    function switch_router(link) {
        navigate(link);
    }

    return (
        <>

            {
                services_info ? (<>
                    {/* 👇 Helmet thêm meta tags */}
                    <Helmet>
                        <title>{services_info.accounts_caption}</title>
                        <meta name="description" content={services_info.accounts_description} />
                        <meta name="copyright" content="Hust Media" />
                        <meta name="author" content="Hust Media" />
                    </Helmet>
                    <div className="min-h-screen p-2 mt-2 sm:p-6">
                        <div className="max-w-6xl mx-auto bg-gradient-to-tr from-sky-50 to-white rounded-2xl shadow-md overflow-hidden border border-dashed border-gray-300">
                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-5 p-2 sm:p-5">

                                {/* RIGHT: Product details */}
                                <section className="mt-1 col-span-2 order-1 lg:order-none">
                                    <div className="px-2 sm:px-6 lg:px-8">
                                        <h1 className="text-xl sm:text-2xl font-extrabold text-gray-800">
                                            {services_info.accounts_caption}
                                        </h1>

                                        <div className="mt-1 sm:mt-2 flex flex-wrap gap-2">
                                            <span className="px-2 py-1 rounded-md bg-purple-400 text-white text-xs sm:text-sm font-semibold">
                                                Kho hàng: {services_info.accounts_amount}
                                            </span>
                                            <span className="px-2 py-1 rounded-md bg-teal-400 text-white text-xs sm:text-sm font-semibold">
                                                Đã bán: {services_info.accounts_sold}
                                            </span>
                                            <span
                                                onClick={() => copy_native(String(services_info.id))}
                                                className="px-2 py-1 rounded-md bg-orange-400 text-white text-xs sm:text-sm font-semibold cursor-pointer select-none"
                                            >
                                                ID: {services_info.id}
                                            </span>
                                        </div>

                                        <div className="mt-2 sm:mt-3 flex items-center justify-between flex-wrap gap-3 sm:gap-4">
                                            <div>
                                                <div className="text-xl sm:text-2xl font-extrabold text-teal-700">
                                                    {services_info.accounts_price} coins
                                                </div>
                                                <div className="mt-1 sm:mt-2 text-gray-600 max-w-2xl text-base sm:text-base">
                                                    {services_info.accounts_description}
                                                </div>
                                            </div>

                                            {/* ORIGINAL simple button block (unchanged) */}
                                            <div className="flex items-center gap-2 w-full sm:w-auto">
                                                <button
                                                    onClick={() => window.history.back()}
                                                    className="flex-1 sm:flex-none px-3 py-2 sm:px-5 sm:py-3 rounded-lg border border-gray-200 text-gray-700 font-medium text-sm sm:text-base"
                                                >
                                                    ↩️ QUAY LẠI
                                                </button>
                                                <button onClick={() => show_orders_vip()} className="flex-1 sm:flex-none px-3 py-2 sm:px-5 sm:py-3 rounded-lg bg-gradient-to-r from-cyan-600 to-sky-700 text-white font-bold shadow-md text-sm sm:text-base">
                                                    🛒 Nhận NGAY
                                                </button>
                                            </div>
                                            {/* THIS block moved into Orders_vip component */}
                                        </div>
                                        {
                                            show_vip && <Orders_vip services_info={services_info} set_accounts_product={set_accounts_product} />
                                        }
                                        {
                                            accounts_product && <Accounts_product accounts_product={accounts_product} />
                                        }
                                    </div>
                                </section>
                                {/* LEFT: Seller panel */}
                                <aside className="col-span-1 flex flex-col items-center order-2 lg:order-none">
                                    <div className="w-full bg-purple-50 rounded-lg border shadow-sm p-2 flex flex-col items-center text-center">
                                        {/* Avatar */}
                                        <div className="w-10 h-10 rounded-full bg-gradient-to-tr from-indigo-500 to-sky-400 flex items-center justify-center text-white text-sm font-bold">
                                            Hust
                                        </div>

                                        {/* Seller name */}
                                        <div className="text-sm font-semibold text-gray-800">
                                            {services_info.shop_caption}
                                        </div>
                                        <div className="text-xs mb-1 text-gray-500">{services_info.shop_description}</div>

                                        {/* Rating & sold */}
                                        <div className="flex items-center gap-1">
                                            <div className="px-1.5 py-0.5 rounded-full bg-emerald-500 text-white text-[11px] font-semibold">
                                                ⭐ 4.9
                                            </div>
                                            <div className="px-1.5 py-0.5 rounded-full bg-rose-500 text-white text-[11px] font-semibold">
                                                Đã bán: 2.2k
                                            </div>
                                        </div>

                                        {/* Chat button */}
                                        <div className="mt-2 w-full flex gap-2">
                                            <a
                                                href={`https://t.me/${services_info.shop_phone}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="flex-1"
                                            >
                                                <button className="w-full py-1 rounded-lg bg-gradient-to-r from-emerald-500 to-green-500 text-white font-semibold shadow text-sm active:scale-95 transition">
                                                    📩 Chat
                                                </button>
                                            </a>
                                            <button onClick={() => switch_router(`/shop/accounts/product/play/shop/${services_info.accounts_seller_id}`)} className="no-underline text-inherit flex-1 py-1 rounded-lg bg-gradient-to-r from-blue-500 to-sky-500 text-white font-semibold shadow text-sm active:scale-95 transition">
                                                ℹ️ Info
                                            </button>
                                        </div>
                                    </div>
                                    {
                                        !accounts_product && <>  <div className="mt-2 grid grid-cols-2 gap-2 sm:gap-4">
                                            <div className="bg-sky-50 rounded-lg px-2 py-0.5 sm:rounded-xl sm:px-5 sm:py-2 border shadow-sm">
                                                <h4 className="mt-1 font-semibold text-gray-800 text-sm">
                                                    Mô tả chi tiết
                                                </h4>
                                                <p className="mt-1 text-gray-600 text-xs">
                                                    Chỉ bảo hành khi mua qua App. Nếu có giới thiệu mua nơi khác sẽ không được bảo hành.
                                                </p>
                                            </div>

                                            <div className="bg-indigo-50 rounded-lg px-2 py-0 sm:rounded-xl sm:px-5  border shadow-sm">
                                                <h4 className="mt-1 font-semibold text-gray-800 text-sm">
                                                    Thông tin shop
                                                </h4>
                                                <ul className="mt-1 space-y-1 sm:space-y-2 text-gray-600 text-xs">
                                                    <li>📍 Việt Nam</li>
                                                    <li>⏱️ 24h</li>
                                                    <li>🔒 Giao dịch tự động</li>
                                                </ul>
                                            </div>
                                        </div> </>
                                    }
                                </aside>
                            </div>
                        </div>
                    </div >
                </>) : (<>
                    <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">
                        <ClipLoader color="#fff" size={150} />
                    </div>
                </>)
            }
        </>
    );
}
